export const webview = {
  webviewContent: 'Toto je externí adresa URL a bude otevřena v novém okně. Otevřít?',
  webviewButtonOpenTitle: 'Otevřít',
  webviewButtonCopyTitle: 'Kopírovat URL',
  webviewButtonOpenAgainTitle: 'Otevřít znovu',
  notifications: {
    urlCopied: 'URL zkopírována!'
  }
}
